//BaseController.js

//=================================================================
// "Abstract" base class of controllers. No need to instantiate
// this class directly.
//
// Lou Mauget, Noverber 27, 2015
//
//=================================================================
class BaseController {

	constructor() {
		// So tests can guarantee  our instance hierarchy is a singlton
		//BaseController.instanceCount = BaseController.instanceCount === undefined ? 0 : BaseController.instanceCount + 1 ;
	}

	remove(){}

	//------------ For tests asserting extender is a singlton: ---

	//static get instanceCount() { return BaseController._instanceCount; 	}
    //
	//static set instanceCount(arg) { BaseController._instanceCount = arg; }
    //
	//get instanceCount() { return BaseController.instanceCount; }

	//----------- End test supports --------------------------
}

export default BaseController;
